export function fullName(user: {
  firstName?: string;
  middleName?: string;
  lastName?: string;
}): string {
  return (
    user ? `${user?.firstName || ''} ${user?.middleName || ''} ${user?.lastName || ''}` : ''
  ).replace('  ', ' ');
}
